import * as React from 'react'
import { defineMessages, FormattedHTMLMessage } from 'react-intl'
import styles from './reason.module.scss'

const messages = defineMessages({
  heading: {
    defaultMessage: 'Därför passar Dooer dig som IT-konsult så bra',
    id: 'consultant.section-one.heading',
  },
  lede: {
    defaultMessage:
      'Det du uppskattar mest som kund hos Dooer är hur skönt det är att all administration som fakturor, kvitton och lönehantering nu bara är gjort och är en fröjd att följa och titta på. Som att komma hem till ett nystädat hus varje dag.',
    id: 'consultant.section-one.lede',
  },
})

export default function Reason() {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <FormattedHTMLMessage tagName="h2" {...messages.heading} />
        <FormattedHTMLMessage tagName="p" {...messages.lede} />
      </div>
    </div>
  )
}
